import { AreaAndScatterChart } from "../Global/AreaAndScatterChart";

export const AreaAndScatterWidget = (props) => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: props.marginTop, width: '100%', height: props.height}}>
            <AreaAndScatterChart data={props.data} name={props.name} nameScatter={props.nameScatter}/>
            <p style={{fontWeight: 'bold', color: '#659767', margin: '5px 0 0 0', fontSize: 'small'}}>{props.label}</p>
        </div>
    )
}